<template>
  <div class="form-group filter-item">
    <label class="control-label">{{ filter.label }}</label>
    <v-select-paginated
      :search-type="filter.search_type"
      :multiple="filter.multiple"
      :is-invalid="filter.errors"
      :reduce="i => i"
      :value="filter.value"
      :addition-params="additionParams"
      @update:value="selectFilter"
      @option:deselected="$emit('option:deselected', true)"
    />
  </div>
</template>
<script>
import VSelectPaginated from '@core/components/v-select-paginated'

export default {
  components: {VSelectPaginated},
  props: {
    filter: Object,
    selectedFilters: Array
  },
  computed: {
    additionParams() {
      let items = {}

      this.selectedFilters.filter(filter => {
          return filter.search_type
        })
        .forEach(filter => {
          items[filter.key] = filter.multiple ? filter.value.map((v) => v.id) : filter.value.id
        })

      if (this.$route.query.tab === 'keywords') {
        items.project_id = this.$route.params.id;
      }
      return items;
    }
  },
  methods: {
    selectFilter(val) {
      if (this.filter.multiple && !val.length) {
        this.$set(this.filter, 'value', null);
      } else {
        this.$set(this.filter, 'value', val);
      }

      this.$emit('value-updated');
    },
  }

}
</script>
